import { MEMBERS } from "@/lib/api";

const TONES = {
  pink: "border-pink-500 bg-pink-500/15 text-pink-100",
  amber: "border-amber-400 bg-amber-400/15 text-amber-100",
  sky: "border-sky-500 bg-sky-500/15 text-sky-100",
  zinc: "border-zinc-400 bg-zinc-500/20 text-zinc-100",
};

export default function MemberPicker({ value, onChange, testPrefix, tone = "pink" }) {
  const toggle = (m) => onChange(value.includes(m) ? value.filter((x) => x !== m) : [...value, m]);
  return (
    <div className="flex flex-wrap gap-2" data-testid={`${testPrefix}-picker`}>
      {MEMBERS.map((m) => (
        <button
          key={m}
          type="button"
          data-testid={`${testPrefix}-${m.toLowerCase()}`}
          aria-pressed={value.includes(m)}
          onClick={() => toggle(m)}
          className={`rounded-full border px-3 py-1.5 text-sm transition-colors duration-200 ${value.includes(m) ? TONES[tone] : "border-zinc-700 text-zinc-400 hover:border-zinc-500"}`}
        >
          {m}
        </button>
      ))}
    </div>
  );
}
